import { useMemo, useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { checkboxCheck, checkboxUncheck} from "../../../utility-functions/assetLoader";
import { CustomChip } from './customComponents';
import styles from '../styles';
import { MenuItem } from '@mui/material';
import colors from '../colors';

export default function GMultiSelect({
  label = "",
  options = [],
  defaultValue = "Select",
  value,
  selectStyles = {},
  disabled = false,
  handleDeleteChip = () => null,
  handleChange = () => null,
  disableOption = () => false
}) {

  const [inputValue, setInputValue] = useState('');

  const optionMap = useMemo(() => {
    const obj = {}
    options.forEach((opt) => {
      obj[opt.value] = opt.displayValue
    });
    return obj;
  }, [options]);  

  return (
    <>
    <label className='t7 medium-font nc-gray-900'>{label}</label>
    <Autocomplete
      multiple
      size='small'
      aria-multiline={false}
      options={Object.keys(optionMap)}
      value={value}
      onChange={(e, newValue) => handleChange(newValue.map(val => !isNaN(val) ? Number(val) : val))}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      disableCloseOnSelect
      disableClearable
      disabled={disabled}
      clearIcon={<span/>}
      limitTags={3}
      getOptionLabel={(option) => optionMap[option]}
      isOptionEqualToValue={(option, value) => {
        return !isNaN(option) ? Number(option) === Number(value) : option === value
      }}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        return (
          <MenuItem
           key={key} 
           value={!isNaN(option) ? Number(option) : option} 
           {...optionProps}
           sx={{
            ...styles.t7,
            ...styles.regular_font,
            ...styles.nc_gray_900,
            padding: '0 !important',
            backgroundColor: `${colors.ic_white} !important`,
            '&:hover': {
              backgroundColor: `#FAFAFA !important`,
            },
            whiteSpace: 'normal'
           }}
           disabled={disableOption(option)}
          >
            <Checkbox
              icon={checkboxUncheck()}
              checkedIcon={checkboxCheck()}
              style={{marginLeft: '10px'}}
              checked={selected}
              disableRipple
              disabled={disableOption(option)}
            />
            {optionMap[option]}
          </MenuItem>
        );
      }}
      popupIcon={<span/>}
      style={{ width: '100%'}}
      sx={{
        ".Mui-focused fieldset.MuiOutlinedInput-notchedOutline": {
          border: '1px solid #34cb65'
        },
        "& .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
          paddingTop: '3px',
          paddingBottom: '3px'
        },
        "& .MuiOutlinedInput-root": {
          maxHeight: '36px',
          paddingRight: '10px !important',
          "& .MuiAutocomplete-input": {
            padding: '2.5px 4px !important'
          }
        },
        ...selectStyles
      }}
      ListboxProps={{sx: {
        ...localStyles.scrollbar,
        border: "1px solid #E4E4E7",
        maxHeight: '250px'
      }}}
      renderInput={(params) => (
        <TextField 
          {...params}
          label="" 
          placeholder={value?.length === 0 ? defaultValue : ""} 
          sx={{
            "..MuiTextField-root .MuiInputBase-input::placeholder": {
              ...styles.t7,
              ...styles.nc_gray_900,
              ...styles.regular_font,
            }
          }}
          multiline={false}
          rows={1}
        />
      )}
      renderTags={(value, getTagProps) =>
        <div style={{maxWidth: 'calc(100% - 50px)', overflow: 'hidden', maxHeight: '36px', display: 'flex', flexDirection: 'row', flexWrap: 'nowrap'}}>
          {value.map((option, index) =>
            <CustomChip
              key={option}
              label={optionMap[option]}
              onDelete={() => handleDeleteChip(!isNaN(option) ? Number(option) : option, value)}
            />
          )}
        </div>
      }
    />
    </>
  );
}

const localStyles = {
  scrollbar: {
    "&::-webkit-scrollbar": {
      background: "transparent",
      width: "8px",
      opacity: 0,
      height: 0,
    },
    "&::-webkit-scrollbar-track-piece": {
      background: "transparent", 
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "transparent",
      width: "8px",
      borderRadius: "3px",
      transition: "all 0.3s ease-in-out",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
      width: "8px",
    },
    "&::-webkit-scrollbar-corner": {
      display: "none"
    },
    "&::-webkit-scrollbar-button": {
      display: "none"
    },
    "&:hover::-webkit-scrollbar-thumb": {
      background: "#c6ccc8"
    }
  }
}